const filterConfig = {
  type: 'object',
  properties: {
        // customer_id: { 
        //     type: 'integer', 
        // },
        // report_id: { 
        //     type: 'integer', 
        // },
        start_date: {
          type: "string",
          format: "date",
        },
        end_date: {
          type: "string",
          format: "date",
        },
        search: {
            type: 'string',
        },
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;